import { isDefined } from "@clipboard-health/util-ts";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { type PlacementWithDetails } from "../../../api/useFetchPaginatedPlacements";
import { formatPayRange } from "../../../utils";
import { PlacementSectionTemplate } from "./PlacementSectionTemplate";

interface PayDetailsSectionProps {
  placement: PlacementWithDetails;
}

export function PayDetailsSection(props: PayDetailsSectionProps) {
  const { placement } = props;

  const payRange = formatPayRange({
    payRange: placement.payRange,
    showPerHour: true,
    withFractionDigits: true,
  });

  return (
    <PlacementSectionTemplate title="Pay details" iconType="coin">
      <Text variant="body2">{isDefined(payRange) ? payRange : "TBD"}</Text>
    </PlacementSectionTemplate>
  );
}
